import Vue from "vue";
import axios from "axios";
import { API_URL } from "@/common/config.js";

Vue.use(axios);

const api = axios.create({
  baseURL: API_URL
})

export const ApiService = {

  get (endpoint) {
    return api.get(endpoint)
  },

  post (endpoint, body) {
    return api.post(endpoint, body)
  }
  
}